import React, { useEffect }from "react";
import './App.css';
import { Navigate, useNavigate, Routes, Route } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { loginSuccess, logout, setLoginError, clearLoginError } from "./components/redux/authSlice";
import SignIn from "./components/authentication/SignIn";
import Home from "./components/common/Home/Home";
import { Toaster, toast } from "react-hot-toast";
import { CheckCircle } from "lucide-react";
import LoadingOverlay from "./components/plugins/LoadingOverlay";
import SessionTimeout from "./components/authentication/SessionTimeout";
import { showLoading, hideLoading } from "./components/redux/loadingSlice"; 
import AddVideo from "./components/plugins/Add/AddVideo";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
function App() {
  const { isLoggedIn, loginError , accessToken} = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    if (!accessToken) {
      navigate("/");
    }
  }, [accessToken, navigate]);
  useEffect(() => {
    if (loginError) {
      toast.error(loginError, {
        duration: 4000,
        position: "top-center",
        style: {
          fontSize: window.innerWidth >= 3840 ? "32px" : window.innerWidth >= 2560 ? "24px" : "16px",
          padding: "10px",
          background: "#f44336",
          color: "#fff",
        },
      });
    }
  }, [loginError]);
  const handleLoginSuccess = async (accessToken) => {
    dispatch(showLoading())
    try {
      if (!accessToken) {
        dispatch(setLoginError("Unauthorized access. Please contact support."));
        return;
      }
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}token/${process.env.REACT_APP_CODED_ID}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({})
        
      });
      if (response.ok) {
        const data = await response.json();
        dispatch(loginSuccess({ accessToken: data.credentials, role: data.role }));
        navigate("/home");
      } else if (response.status === 401) {
        dispatch(setLoginError("Unauthorized access. Please contact support."));
      } else {
        dispatch(setLoginError("Login failed. Please try again."));
      }
    } catch (error) {
      dispatch(setLoginError("An error occurred. Please try again."));
    } finally {
      setTimeout(() => {
        dispatch(hideLoading());
      },3000);
    }
  };
  const handleLogout = () => {
    dispatch(logout());
    dispatch(showLoading())
    setTimeout(() => {
      dispatch(hideLoading()); 
    navigate("/");
  },4000);
    toast.success("Logged out successfully!", {
      icon: <CheckCircle size={window.innerWidth >= 3840 ? 56 : window.innerWidth >= 2560 ? 48 : 24} />,
      style: {
        fontSize: window.innerWidth >= 3840 ? "32px" : window.innerWidth >= 2560 ? "24px" : "16px",
        padding: "12px 20px",
        width: "auto",
        height: "auto",
      },
      className: "custom-toast", 
    });
  };
  return (
    <>
    <LoadingOverlay/>
           {isLoggedIn && <SessionTimeout/>}
    <Routes>
      <Route
        path="/"
        element={
          !isLoggedIn ? (
            <SignIn
              onLoginSuccess={handleLoginSuccess}
              loginError={loginError}
              clearLoginError={() => dispatch(clearLoginError())}
            />
          ) : (
            <Navigate to="/video" replace />
          )
        }
      />
      <Route path="/home" element={<ProtectedRoute element={<Home onLogout={handleLogout} />} />} />
      <Route path="/video" element={<ProtectedRoute element={<AddVideo onLogout={handleLogout} />} />} />
    </Routes>
    <Toaster position="top-center" reverseOrder={false} />
     </>
  );
}
export default App;
